export const SET_FILE = "SET_FILE";

// ACTION CREATORS

export default function _setFile(file, userData) {
  // console.log(file);

  return {
    type: SET_FILE,
    file,
    userData,
  };
}



// WEBPACK FOOTER //
// ./src/Containers/BulkValidation/actions.js